import React, { useEffect, useState } from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import { object, array } from "prop-types";

import { MetypeContributionWidget } from "../../atoms/metype-ugc";

import { getEntities } from "../../helper/api";

import "./ugc.m.css";

const UgcPageBase = ({ publisherAttributes, storyAttributes }) => {
  const [entities, setEntities] = useState([]);
  const [currentItem, setCurrentItem] = useState("");
  const { metypeConfig, publisherName, metypeUgcConfig } = publisherAttributes;
  const metypeObj = metypeUgcConfig || metypeConfig;
  const [isIframe, setIframe] = useState(false);

  useEffect(() => {
    const ugcStoryAttribute =
      storyAttributes.length > 0 ? storyAttributes.find((item) => item.name === "ugctopic") : null;

    if (ugcStoryAttribute && ugcStoryAttribute.values.length) {
      if (ugcStoryAttribute["data-type"] === "entity") {
        getEntities(ugcStoryAttribute.values[0]).then((data) => {
          const entities = data.entities.map((item) => item.name);
          setEntities(entities);
        });
      } else if (ugcStoryAttribute["data-type"] === "multi-valued-strings") {
        setEntities(ugcStoryAttribute.values);
      }
    }
  }, []);

  useEffect(() => {
    setIframe(true);
  }, []);

  const onChangeFunc = (e) => {
    setCurrentItem(e.target.value);
    if (window.talktype) {
      window.talktype.updateUGCTopic({
        topicType: "ugctopic",
        topicValue: e.target.value,
      });
    }
  };

  return (
    <div styleName="ugc-wrapper">
      {isIframe && (
        <MetypeContributionWidget
          host={metypeObj.metypeHost}
          accountId={metypeObj.metypeAccountId}
          publisher={publisherName}
          entities={entities}
          onChangeFunc={onChangeFunc}
          currentItem={currentItem}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  storyAttributes: get(state, ["qt", "config", "story-attributes"], []),
});

UgcPageBase.propTypes = {
  publisherAttributes: object,
  storyAttributes: array,
};

export const UgcPage = connect(mapStateToProps)(UgcPageBase);
